import { useClassified } from "@/contexts/classified";
import { getTrackingQueryParams } from "./utils/getTrackingQueryParams";
import { useTrackingPromotion } from "./useTrackingPromotion";
import { useIsNewBuildProject } from "@/shared/hooks";
export const useTrackingDatas = () => {
    var _a;
    const { list_name } = getTrackingQueryParams();
    const isNewBuildProject = useIsNewBuildProject();
    const classifiedTrackingData = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.tracking;
    const newBuildProjecttTrackingData = useNewBuildProjectUnitLists();
    const promotion = useTrackingPromotion();
    const trackingData = isNewBuildProject
        ? newBuildProjecttTrackingData
        : classifiedTrackingData;
    return {
        ...trackingData,
        av_initiative: isNewBuildProject ? "wl_pdp" : trackingData === null || trackingData === void 0 ? void 0 : trackingData.av_initiative,
        av_items: trackingData === null || trackingData === void 0 ? void 0 : trackingData.av_items.filter((item) => item.list_name !== "classified_detail_similars_bottom").map((item) => ({
            ...item,
            list_name: item.index === 0 && list_name ? list_name : item.list_name,
            ...(promotion && { promotion }),
        })),
    };
};
export const useTrackingAvDistributionType = () => { var _a, _b; return (_b = (_a = useTrackingDatas()) === null || _a === void 0 ? void 0 : _a.av_distribution_type_global) !== null && _b !== void 0 ? _b : ""; };
const useItemsDatas = (conversionType) => {
    const { av_items } = useTrackingDatas();
    const [currentItem, ...rest] = av_items !== null && av_items !== void 0 ? av_items : [];
    return conversionType
        ? [{ ...currentItem, conversion_type: conversionType }, ...rest]
        : av_items;
};
// Add newBuildProject unit lists to the tracking data
const useNewBuildProjectUnitLists = () => {
    var _a, _b, _c, _d;
    const trackingData = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.tracking;
    const unitLists = (_c = (_b = useClassified()) === null || _b === void 0 ? void 0 : _b.units) === null || _c === void 0 ? void 0 : _c.units;
    const isNewBuildProject = useIsNewBuildProject();
    if (isNewBuildProject && (unitLists === null || unitLists === void 0 ? void 0 : unitLists.length) > 0) {
        const unitListsTrackingData = unitLists === null || unitLists === void 0 ? void 0 : unitLists.map((item, index) => {
            var _a, _b, _c, _d, _e, _f, _g;
            return ({
                ...item,
                index: ((_a = trackingData === null || trackingData === void 0 ? void 0 : trackingData.av_items) === null || _a === void 0 ? void 0 : _a.length) + index,
                product_type: "project",
                project_online_id: (_c = (_b = trackingData === null || trackingData === void 0 ? void 0 : trackingData.av_items) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.project_online_id,
                estate_type: "av_10",
                list_name: "classified_detail_associated_estate",
                conversion_type: (_e = (_d = trackingData === null || trackingData === void 0 ? void 0 : trackingData.av_items) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.conversion_type,
                province: (_g = (_f = trackingData === null || trackingData === void 0 ? void 0 : trackingData.av_items) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.province,
            });
        });
        return {
            ...trackingData,
            av_items: [...((_d = trackingData === null || trackingData === void 0 ? void 0 : trackingData.av_items) !== null && _d !== void 0 ? _d : []), ...unitListsTrackingData],
        };
    }
    return trackingData;
};
export const useTrackingEventsDatas = ({ conversionType, displayMedium, }) => ({
    ...useTrackingEventsDatasNoItems(displayMedium),
    av_items: useItemsDatas(conversionType),
});
export const useTrackingEventsDatasNoItems = (displayMedium = false) => {
    var _a, _b, _c, _d;
    const { av_medium } = getTrackingQueryParams();
    const shouldDisplayMedium = displayMedium && !!av_medium;
    return {
        av_distribution_type_global: useTrackingAvDistributionType(),
        av_estate_type_global: (_b = (_a = useTrackingDatas()) === null || _a === void 0 ? void 0 : _a.av_estate_type_global) !== null && _b !== void 0 ? _b : "",
        av_category: (_d = (_c = useTrackingDatas()) === null || _c === void 0 ? void 0 : _c.av_category) !== null && _d !== void 0 ? _d : "",
        ...(shouldDisplayMedium && { av_medium }),
    };
};
